var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pdfUrl)?_c('VistaPreviaPdf',{attrs:{"rutaArchivo":_vm.pdfUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }